import React from 'react';
import { useTheme, useMediaQuery, Grid } from '@material-ui/core';
import Navbar from '../../components/Navbar/Navbar';
import SearchBox from '../../components/SearchBox/SearchBox';
import AppLogo from '../../components/AppLogo/AppLogo';
import CurrentLocation from '../../components/CurrentLocation/CurrentLocation';
import { isKickCovidDomain } from '../../common/helpers';
import PoweredByLauktiLogo from '../../assets/logos/powered_by_laukti_logo.svg';
import PoweredByLauktiLogoStack from '../../assets/logos/powered_by_laukti_logo_stack.svg';
import useStyles from './Home.styles';

const Home = () => {
  const classes = useStyles();

  const theme = useTheme();
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('xs'));

  const getPoweredByLauktiLogo = () => {
    if (isExtraSmall) {
      return <img className={classes.poweredByLogo} src={PoweredByLauktiLogo} alt="Powered By Laukti"></img>;
    } else {
      return <img className={classes.poweredByLogoStack} src={PoweredByLauktiLogoStack} alt="Powered By Laukti"></img>;
    }
  };

  const getParagraph = () => {
    return (
      <div className={classes.paragraph}>
        <p>
          {isKickCovidDomain() ? 'KickCOVID.us powered by Laukti' : 'Laukti'} is a free site that provides COVID-19
          related safety data for places you frequent or may want to visit. Our data is crowdsourced by people like you.
          It’s easy to use:
        </p>
        <p>
          <span className={classes.keyword}>Find</span> a location, <span className={classes.keyword}>View</span> the
          safety information, <span className={classes.keyword}>Update</span> the information after your visit and{' '}
          <span className={classes.keyword}>Share</span> with everyone!
        </p>
        <p>Spread the word, not the virus!</p>
      </div>
    );
  };

  const getCurrentLocation = () => {
    return (
      <div className={classes.locationContainer}>
        <CurrentLocation />
      </div>
    );
  };

  const getPageContent = () => {
    if (isKickCovidDomain()) {
      return (
        <div className={classes.k_content}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <AppLogo />
            </Grid>
          </Grid>
          <Grid className={classes.k_textContainer} container direction="row" justify="center" alignItems="center">
            <Grid item xs={11} sm={9}>
              {getParagraph()}
            </Grid>
          </Grid>
          <Grid className={classes.searchBoxContainer} container direction="row" justify="center" alignItems="center">
            <Grid item xs={11} sm={10} lg={8}>
              <SearchBox showHints />
              {getCurrentLocation()}
            </Grid>
          </Grid>
          <Grid
            className={classes.poweredByLogoContainer}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item>
              <a href="https://www.laukti.com">{getPoweredByLauktiLogo()}</a>
            </Grid>
          </Grid>
        </div>
      );
    } else {
      return (
        <div className={classes.content}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <AppLogo />
            </Grid>
          </Grid>
          <Grid className={classes.searchBoxContainer} container direction="row" justify="center" alignItems="center">
            <Grid item xs={11} sm={10} lg={8}>
              <SearchBox showHints />
              {getCurrentLocation()}
            </Grid>
          </Grid>
          <Grid className={classes.textContainer} container direction="row" justify="center" alignItems="center">
            <Grid item xs={11} sm={9}>
              {getParagraph()}
            </Grid>
          </Grid>
        </div>
      );
    }
  };

  return (
    <div className={classes.root}>
      <Navbar showMenuButtonOnly={true} />
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12} sm={12} md={9}>
          {getPageContent()}
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(Home);
